module.exports = {
	"config": {
		"dataLayer": "newDataLayer"
	},
	"dk": [
		{
			"containerId": "GTM-54KJVX",
			"environments": {
				"test": {
					"id": "8",
					"auth": "juskbvHmL-oTF848kG0Heg"
				}
			}
		},
		{
			"containerId": "GTM-TV4TR9L",
			"environments": {
				"production": {
					"id": "5",
					"auth": "zFtYfOXK44XplZPFMtrrNA"
				}
			}
		},
		{
			"containerId": "GTM-TV4TR9L",
			"dataLayer": "newDataLayer",
			"environments": {
				"prod": {
					"id": "6",
					"auth": "zFtYfOXK44XplZPFMtrrNA"
				}
			}
		},
		{
			"containerId": "GTM-TV4TR9L",
			"dataLayer": "newDataLayer",
			"environments": {
				"test": {
					"id": "7",
					"auth": "zFtYfOXK44XplZPFMtrrNA"
				}
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/config/googleTagManager.json
// module id = 428
// module chunks = 6